
<template>
  <v-app id="searchMltp">
    <v-main>
      <v-container fluid>  
            <v-card flat>
                <v-row cols="12">
                    <v-col cols="1">
                    </v-col>
                    <v-col cols="10" ><v-card-title class="justify-center">{{this.title}} ({{ this.mltp_doelgroep }})</v-card-title></v-col>
                    <v-col cols="1" v-if="mltp_can_create">
                        <v-spacer/>
                        <btn_plus ref="btn_plus" data="createAction" @actionClick="newTemplate" tooltip="Add action template" :size="20"/>
                    </v-col>
                </v-row>
                <v-divider class="mb-2"/>
                <v-simple-table dense>
                    <thead>
                        <tr>
                            <th>Id</th>
                            <th>Description</th>
                            <th>Remark</th>
                            <th>Company</th>
                            <th>Templates</th>
                            <th v-if="mltp_can_create">Copy</th>
                            <th v-if="mltp_can_create">Delete</th>
                        </tr>
                    </thead>
                    <tbody v-for="(mltpRecord, i) in searchMltp" :key="i">
                        <tr :class="{'color': i%2!==0}">
                            <td>{{ mltpRecord.mltp_nr }}</td>
                            <td>{{ mltpRecord.mltp_oms }}</td>
                            <td>{{ mltpRecord.mltp_opm }}</td>
                            <td>{{ mltpRecord.merk_code }}</td>
                            <td>
                                <div>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="$router.reload('/syst/mltp/onMltp/' + mltpRecord.mltp_encrid)">
                                                <v-icon>mdi-file-document-edit-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Edit templates</span>
                                    </v-tooltip>
                                </div>
                            </td>
                            <td v-if="mltp_can_create">
                                <div v-if="mltpRecord.mltp_can_copy">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="copyTemplate(mltpRecord.mltp_nr)">
                                                <v-icon>mdi-content-copy</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Copy template</span>
                                    </v-tooltip>
                                </div>
                            </td>
                           <td v-if="mltp_can_create">
                                <div v-if="mltpRecord.mltp_can_delete">
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn v-bind="attrs" v-on="on" icon v-on:click="deleteTemplate(mltpRecord.mltp_nr)">
                                                <v-icon>mdi-trash-can-outline</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Delete template</span>
                                    </v-tooltip>
                                </div>
                            </td>
                        </tr>
                    </tbody>  
                </v-simple-table>  
            </v-card>  
        </v-container>
    </v-main>
    <navBar title="Ares - Templates" :home="true" type="mltp"/>   
    <newMltp ref="newMltp" @reload="getData"/>
  </v-app>
</template>


<script>
    import navBar from "@/components/ui/navbars/navbar.vue"
    import btn_plus from "@/components/ui/buttons/btn_plus.vue";
    import newMltp from "@/views/syst/mltp/newMltp.vue";
    
    export default {
        components: {
            navBar,
            btn_plus,
            newMltp
        },
        props: ['mltp_doelgroep'],
        watch: { 
            mltp_doelgroep: function() { // watch it
                this.getData();
            }
        },
        data() {
            return {
                searchMltp: [],
                title: "Mail template overview",
                mltp_can_create: false
            }  
        },
        mounted() { 
            this.getData();
        },
        methods: {
            getData() {
                this.$axios.post("ares/json/ares/syst/mltp/searchMltp2.p", {
                    header: {
                        token: this.$session.get("ARES"),
                        clientSessionId: this.$session.id(),
                        request: "searchMltp"
                    },
                    searchMltp: {
                        mltp_doelgroep: this.mltp_doelgroep
                    }
                }).then(res => {
                    if (res.data.error) {
                        console.log(res.data.error);
                    } else {
                        this.mltp_can_create = res.data.mltp_can_create;
                        this.searchMltp = res.data.searchMltp;
                    }
                });
            },
            newTemplate() {
                this.$refs.newMltp.openNewMltp(0)
            },
            copyTemplate(nr) {
                this.$refs.newMltp.openNewMltp(nr)
            },
            deleteTemplate(nr) {
                console.log(nr)
                // this.$refs.removeMltp.removeMltp(nr)
            }
        }
    };
</script> 


<style scoped>
  .color {
    background-color: #faf8f8;
  }
</style>